import type {
  ControlParameterResponseDto,
  ControlResultColumnResponseDto,
} from "@/spz-api/model";
import { create } from "zustand";

export interface SelectedControlState {
  control: {
    id: string;
    descriptorLabelKeyName: string;
    currency: string;
    parameters: ControlParameterResponseDto[];
    controlResultColumns: ControlResultColumnResponseDto[];
  } | null;
  setSelectedControl: (
    control: {
      id: string;
      descriptorLabelKeyName: string;
      currency: string;
      parameters: ControlParameterResponseDto[];
      controlResultColumns: ControlResultColumnResponseDto[];
    } | null,
  ) => void;
  clearSelectedControl: () => void;
}

export const useSelectedControlStore = create<SelectedControlState>((set) => ({
  control: null,
  setSelectedControl: (control) => set({ control }),
  clearSelectedControl: () => set({ control: null }),
}));
